import { Table, TableBody, TableContainer, TableHead } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Fragment } from "react";
import AddButton from "../addButton/AddButton";
import { SxProps } from "@mui/system";

interface Props {
  header?: JSX.Element;
  items: JSX.Element[];
  canAdd?: boolean;
  addItem?: () => void;
  accessRightChecks?: ((user: any) => boolean)[];
  tableSx?: SxProps;
  addButtonVariant?: "contained" | "outlined" | "text";
}

export const SimpleTable = ({
  header,
  items,
  canAdd = true,
  addItem,
  accessRightChecks,
  tableSx = {},
  addButtonVariant,
}: Props) => {
  const { t } = useTranslation("talentProfile");

  // TODO use SimpleTableHeader instead of header prop
  // TODO create and use SimpleTableItem instead of items prop
  // -> refactoring needs to be done for other components that use SimpleTable
  return (
    <>
      {items.length > 0 && (
        <TableContainer>
          <Table sx={tableSx}>
            <TableHead>{header}</TableHead>
            <TableBody>
              {items.map((item, i) => (
                <Fragment key={item.key ?? i}>{item}</Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {addItem ? (
        <AddButton
          accessRightChecks={accessRightChecks}
          onClick={addItem}
          disabled={!canAdd}
          label={t("common:add")}
          variant={addButtonVariant}
        />
      ) : null}
    </>
  );
};
